import React, { useContext } from 'react';
import { BrandingContext } from '../contexts/ContractContext';
import Footer from './Footer';
import { NJRFooter } from './NJR/NJRFooter';
import AppleFooter from './AppleFooter/AppleFooter';

export const FooterController = () => {
    const branding = useContext(BrandingContext);
    const { clientId } = branding;

    switch (clientId?.toLowerCase()) {
        case 'njr':
            return <NJRFooter />;
        case 'apple':
            return <AppleFooter />;
        default:
            return <AppleFooter />;
    }
};
